const Resources = {

    table_headers: [
        { 
            text:   'Assignment #',
            value:  'number_assigment',
            type:   'link',
        },
        { 
            text:   'Description',
            align:  'start',
            value:  'description',
            type:   'link',
        },
        { 
            text: 'Days/Week',   
            value: 'days_per_week'
        },
        {   
            text: 'Avg. Time',
            value: 'avg_time_day'
        },
        {   
            text: 'Census',
            value: 'census',
            type: 'boolean'
        },
        { 
            text: 'Shift',
            value: 'shift'
        },
        { 
            text: 'Associate',
            value: 'associate'
        },
        { 
            text: 'Supervisor',
            value: 'supervisor'
        },
    ],

    room_complete_table_headers: [
        {
            name:       'Room',
            model:      '',
            checkbox:   false,
            id:         'room',
        },
        {
            name:       'Task',
            model:      '',
            checkbox:   false,
            id:         'task',
        },
        {
            name:       'Step codes',
            model:      '',
            checkbox:   false,
            id:         'step_codes',
        },
        {
            name:       '#',
            model:      '',
            checkbox:   false,
            id:         'hash',
        },
    ],

    lite_assignment_table_headers: [
        { 
            name:   'Assignment',
        },
        {   
            name:   'Frequency',
        },
    ],
    
    bed_table_headers: [
        { 
            text:   'Bed code',
            value:  'bed_code',
        },
        { 
            text:   'Room',
            value:  'room',
        },
        { 
            text:   'Minutes',
            value:  'minutes',
        },
        { 
            text:   'Added at',
            value:  'created_at',
        },
    ],

    employee_table_headers: [
        { 
            text:   'Assignment #',
            value:  'number_assigment',
            type:   'link',
        },
        { 
            text:   'Description',
            align:  'start',
            value:  'description',
            type:   'link',
        },
        { 
            text: 'Days/Week',   
            value: 'days_per_week'
        },
    ],

    note_table_headers: [
        { 
            name:   'Select',
        },
        {   
            name:   'Assignment #',
        },
        { 
            name:   'Description',
        },
    ],

    room_table_headers: [
        {
            name:       'Room',
            model:      '',
            checkbox:   false,
            id:         'room',
        },
        {
            name:       'Task',
            model:      '',
            checkbox:   false,
            id:         'task',
        },
        {
            name:       'Mon',
            model:      'monday',
            checkbox:   true,
            id:         'mon',
        },
        {
            name:       'Tue',
            model:      'tuesday',
            checkbox:   true,
            id:         'tue',
        },
        {
            name:       'Wed',
            model:      'wednesday',
            checkbox:   true,
            id:         'wed',
        },
        {
            name:       'Thu',
            model:      'thursday',
            checkbox:   true,
            id:         'thu',
        },
        {
            name:       'Fri',
            model:      'friday',
            checkbox:   true,
            id:         'fri',
        },
        {
            name:       'Sat',
            model:      'saturday',
            checkbox:   true,
            id:         'sat',
        },
        {
            name:       'Sun',
            model:      'sunday',
            checkbox:   true,
            id:         'sun',
        },
        {
            name:       'Min',
            model:      '',
            checkbox:   false,
            id:         'min',
        },
        {
            name:       'SQ Ft',
            model:      '',
            checkbox:   false,
            id:         'sqft',
        },
        {
            name:       '#',
            model:      '',
            checkbox:   false,
            id:         'n',
        },
    ],

    week_table_headers: [
        {
            name: 'Mon',
        },
        {
            name: 'Tue',
        },
        {
            name: 'Wed',
        },
        {
            name: 'Thu',
        },
        {
            name: 'Fri',
        },
        {
            name: 'Sat',
        },
        {
            name: 'Sun',
        },
    ],

    schedule_models: {
        'monday':     false,
        'tuesday':    false,
        'wednesday':  false,
        'thursday':   false,
        'friday':     false,
        'saturday':   false,
        'sunday':     false,
    },

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Daily Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "",
        },
    ],


    breadcrumb_for_modals:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash-medium'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash-medium'>/</span>",
        }
        
    ],


    breadcrumb_employee:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
    
    ],

    boolean_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    excl_options:[
        {
            id:     true,
            name:   'Yes',
        },
        {
            id:     false,
            name:   'No',
        },
    ],

    

    freq_options:[
        {
            id:     1,
            name:   '=',
        },
        {
            id:     2,
            name:   '<',
        },
        {
            id:     3,
            name:   '>',
        },
    ],

    excel_file_headers: {
        'Assignment #': 'number_assigment',
        'Description': 'description',
        'Associate': 'associate_id',
        'Supervisor': 'supervisor_id',
        'Shift': 'shift_id',
        'Group': 'group_id',
        'Department': 'cost_center_department_id',
        'Associate pager': 'associate_pager',
        'Supervisor pager': 'supervisor_pager',
        'Days per week': 'days_per_week',
        'Include in census': 'census',
        'Minutes/discharge': 'minutes'
    },

    empty_format_data: [
        {
            number_assigment: '',
            description: '',
            associate_id: '',
            supervisor_id: '',
            shift_id: '',
            group_id: '',
            cost_center_department_id: '',
            associate_pager: '',
            supervisor_pager: '',
            days_per_week: 0,
            census: false,
            minutes: 0
        },
    ],

    excel_fields_required: {
        number_assigment: true,
        description: true,
        associate_id: false,
        supervisor_id: false,
        shift_id: true,
        group_id: false,
        cost_center_department_id: false,
        associate_pager: false,
        supervisor_pager: false,
        days_per_week: true,
        census: false,
        minutes: false,
    },

    excel_file_headers_rooms: {
        'Room': 'room_id',
        'Task': 'task_id',
        'Sunday': 'sunday',
        'Monday': 'monday',
        'Tuesday': 'tuesday',
        'Wednesday': 'wednesday',
        'Thursday': 'thursday',
        'Friday': 'friday',
        'Saturday': 'saturday',
    },

    empty_format_data_rooms: [
        {
            'room_id': '',
            'task_id': '',
            'sunday': false,
            'monday': false,
            'tuesday': false,
            'wednesday': false,
            'thursday': false,
            'friday': false,
            'saturday': false,
        },
    ],

    excel_fields_required_rooms: {
        room_id: true,
        task_id: true,
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
    },

}

export default Resources;